import { render, staticRenderFns } from "./item_actions.vue?vue&type=template&id=383db6c7&scoped=true&"
import script from "./item_actions.vue?vue&type=script&lang=js&"
export * from "./item_actions.vue?vue&type=script&lang=js&"
import style0 from "./item_actions.vue?vue&type=style&index=0&id=383db6c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383db6c7",
  null
  
)

export default component.exports